import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "StudentImpactVideoCompleteWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "wistia_responsive_padding StudentImpactVideoPositioningWrapper" }, [
      _createElementVNode("div", { class: "wistia_responsive_wrapper StudentImpactVideoInBetweenWrapper" }, [
        _createElementVNode("div", { class: "wistia_embed StudentImpactVideoInnerWrapper wistia_async_2kf74ltl9z videoFoam=true" }, [
          _createElementVNode("div", { class: "wistia_swatch StudentImpactVideoSwatch" }, [
            _createElementVNode("img", {
              class: "StudentImpactVideoImage",
              src: "https://fast.wistia.com/embed/medias/2kf74ltl9z/swatch",
              alt: "",
              "aria-hidden": "true",
              onload: "this.parentNode.style.opacity=1;"
            })
          ])
        ])
      ])
    ], -1 /* CACHED */)
  ]))]))
}